module.exports = __webpack_public_path__ + "img/ats-1.35632be4.gif";